import { makeAutoObservable } from 'mobx'
import { RequestType } from '../../SingleRequestPage/types/Request.type'

type RequestCollectionType =
  | 'install'
  | 'impossible'
  | 'uncompleted'
  | 'clarify'
  | 'reportedEdit'

const initImages = {
  install: [],
  impossible: [],
  uncompleted: [],
  clarify: [],
  reportedEdit: [],
}

export type ModeType = 'default' | 'duplicate' | 'impossible' | 'to-rework'

class NewRequestDrawerStore {
  isOpen = false
  request: RequestType | null = null
  images: Record<RequestCollectionType, string[]> = initImages
  mode: ModeType = 'default'

  constructor() {
    makeAutoObservable(this)
  }

  openDrawer = (isOpen: boolean, request: RequestType) => {
    this.isOpen = isOpen
    this.request = request
  }

  setMode = (mode: ModeType) => {
    this.mode = mode
  }

  onBack = () => {
    if (this.mode === 'default') {
      this.closeDrawer()
    }

    this.mode = 'default'
  }

  closeDrawer = () => {
    this.isOpen = false
    this.request = null
    this.images = initImages
    this.mode = 'default'
  }

  getImages = (images: any) => {
    this.images = initImages

    for (const collectionKey in images) {
      this.images[collectionKey as RequestCollectionType] = images[
        collectionKey
      ].reduce((filtered: any, image: any) => {
        if (!image.isRemoved) {
          image.url =
            // @ts-ignore
            window.SAT.config.apiUrl + `/images/getimage?imageId=${image.id}`
          filtered.push(image)
        }
        return filtered
      }, [])
    }
  }

  updateRequest = (request: Partial<RequestType>) => {
    if (!this.request) return
    this.request = { ...this.request, ...request }
  }
}

export const newRequestDrawerStore = new NewRequestDrawerStore()
